export default class Office {
  static VIRTUAL_OFFICE = new Office({ id: -1 })

  /**
   * @type {number}
   */
  id;

  /**
   * @type {string}
   */
  address;

  /**
   * @type {string}
   */
  city;

  /**
   * @type {string}
   */
  state;

  /**
   * @type {string}
   */
  zip;

  /**
   * @type {string}
   */
   phone;

  /**
   * @type {string}
   */
  imageUrl = 'https://mmtax-public.s3.amazonaws.com/office-images/default.png';

  /**
   * @type {number}
   */
  distanceInMiles = 0.0;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.address != null) {
        this.address = opts.address;
      }
      if (opts.city != null) {
        this.city = opts.city;
      }
      if (opts.state != null) {
        this.state = opts.state;
      }
      if (opts.zip != null) {
        this.zip = opts.zip;
      }
      if (opts.phone != null) {
        this.phone = opts.phone;
      }
      if (opts.imageUrl != null) {
        this.imageUrl = opts.imageUrl;
      }
      if (opts.distanceInMiles != null) {
        this.distanceInMiles = Math.round(opts.distanceInMiles * 10) / 10;
      }
    }
  }

  isVirtualOffice() {
    return this.id === Office.VIRTUAL_OFFICE.id;
  }
}
